import React, { createContext, useCallback, useEffect, useState } from 'react';
import PropTypes                                                  from 'prop-types';
import { getHostname }                                            from '@karpeleslab/klbfw';
import { useCookies }                                             from 'react-cookie';
import { getCookiesOptions }                                      from '../utils/misc';

export const ADVANCED_MODE = 'ADVANCED_MODE';
export const LITE_MODE = 'LITE_MODE';

export const defaultModeContext = { mode: ADVANCED_MODE };
export const ModeContext = createContext(defaultModeContext);

export const ModeContainer = ({ children }) => {
	const [modeContext, setModeContext] = useState(defaultModeContext);
	const [cookies, setCookies] = useCookies(['mode']);
	const setMode = useCallback(mode => {
		setModeContext({ mode: mode });
	}, [setModeContext]);

	useEffect(() => {
		let mode = ADVANCED_MODE;
		switch (getHostname()) {
			// Set here the mode based on the hostname (for school/business mode)
			default:
				mode = cookies.mode ? cookies.mode : ADVANCED_MODE;
				if (mode === LITE_MODE)
					mode = ADVANCED_MODE;
				break;
		}

		setMode(mode);
		setCookies('mode', mode, getCookiesOptions());
	}, [setMode]);

	return (
		<ModeContext.Provider value={[modeContext.mode, setMode]}>
			{children}
		</ModeContext.Provider>
	);
};

ModeContainer.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired
};
